import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  previousProductsLoaded,
  loadingPreviousProducts,
  loadingMoreProducts,
  moreProductsLoaded,
} from "../../store/actionCreators";
import logger from "../../../../../../lib/logger";
import { getPaginationData } from "../../../selectors";
import { getLocation } from "../../../../router/selectors";
import { updateLocationQuery } from "../../../../router/actions";
import { clearError, setError } from "../../../../error";
import { ERROR_ORIGIN } from "../../../../../../components/ErrorAlert/constants";
import {
  getSearchAction,
  getQueryObject,
  getLocationQuery,
} from "../../query/thunks";

const getSearchRequestIdentifier = (query) => query?.q || query?.cid;

const runLoadPrevious = ({ dispatch, getState }) => {
  const state = getState();
  const location = getLocation(state);
  const locationQuery = getLocationQuery(location);
  const pagination = getPaginationData(state);
  const page = pagination.page.previous;
  if (pagination.offset.previous !== null) {
    dispatch(loadingPreviousProducts());

    const queryObject = getQueryObject({ state }, pagination.offset.previous);

    return getSearchAction(state, queryObject)
      .then((response) => {
        dispatch(clearError());
        dispatch(previousProductsLoaded({ ...response, page }));
      })
      .catch((error) => {
        error.message = `${
          error.message
        } loadPrevious for ${getSearchRequestIdentifier(locationQuery)} failed`;
        logger.error(error);
        dispatch(
          setError({
            message: error.message,
            actionType: previousProductsLoaded.type,
            errorOrigin: ERROR_ORIGIN.search,
          }),
        );
        dispatch(previousProductsLoaded(error));
      });
  }
};

export const loadPreviousThunk = createAsyncThunk(
  "search/loadPrevious",
  async (_, { dispatch, getState }) => runLoadPrevious({ dispatch, getState }),
);

export function loadPrevious() {
  return (dispatch, getState) => runLoadPrevious({ dispatch, getState });
}

const runLoadMore = ({ dispatch, getState }) => {
  const state = getState();
  const location = getLocation(state);
  const query = getLocationQuery(location);
  const pagination = getPaginationData(state);
  const page = pagination.page.next;

  if (pagination.offset.next) {
    const updatedQuery = {
      ...query,
      page,
    };
    dispatch(loadingMoreProducts());
    dispatch(updateLocationQuery({ query: updatedQuery }));

    const queryObject = getQueryObject({ state }, pagination.offset.next);

    return getSearchAction(state, queryObject)
      .then((response) => {
        dispatch(clearError());
        dispatch(moreProductsLoaded({ ...response, page }));
      })
      .catch((error) => {
        error.message = `${
          error.message
        } loadMore for ${getSearchRequestIdentifier(query)} failed`;
        logger.error(error);
        dispatch(
          setError({
            message: error.message,
            actionType: moreProductsLoaded.type,
            errorOrigin: ERROR_ORIGIN.search,
          }),
        );
        dispatch(moreProductsLoaded(error));
      });
  }
};

export const loadMoreThunk = createAsyncThunk(
  "search/loadMore",
  async (_, { dispatch, getState }) => runLoadMore({ dispatch, getState }),
);

export function loadMore() {
  return (dispatch, getState) => runLoadMore({ dispatch, getState });
}
